<div class="auth-header">
	<span class="auth-title">{{ mode === 'signin' ? 'Sign In' : 'Create Account' }}</span>
	<ion-button fill="clear" (click)="dismiss()" aria-label="Close" class="close-btn">
		<ion-icon slot="icon-only" name="close"></ion-icon>
	</ion-button>
</div>

<div class="auth-body">
	<!-- Sign In View (hidden, not destroyed, when inactive) -->
	<div [hidden]="mode !== 'signin'">
		<form [formGroup]="signinForm" (ngSubmit)="onSignin()">
			<ion-list lines="none" class="form-list">
				<ion-item class="form-input">
					<ion-label position="floating">Email</ion-label>
					<ion-input type="email" formControlName="email" clearInput></ion-input>
				</ion-item>
				<ion-item class="form-input">
					<ion-label position="floating">Password</ion-label>
					<ion-input [type]="pwInputType" formControlName="password"></ion-input>
					<ion-button fill="clear" slot="end" (click)="togglePw()" class="password-toggle" aria-label="Toggle password visibility">
						<ion-icon *ngIf="pwInputType === 'password'" size="small" slot="icon-only" name="eye-off-outline" color="medium"></ion-icon>
						<ion-icon *ngIf="pwInputType === 'text'" size="small" slot="icon-only" name="eye-outline" color="secondary"></ion-icon>
					</ion-button>
				</ion-item>
			</ion-list>

			<div class="forgot-password-wrapper">
				<ion-button class="forgot-btn" type="button" (click)="forgotPassword()" fill="clear" color="medium">
					Forgot Password?
				</ion-button>
			</div>

			<ion-button [disabled]="!signinForm.valid" class="flow-submit" type="submit" expand="block">
				<ion-icon slot="start" name="log-in-outline"></ion-icon>
				Sign In
			</ion-button>
		</form>

		<ng-container *ngIf="showGoogleSignIn || showAppleSignIn">
			<div class="divider-wrapper">
				<div class="divider-line"></div>
				<span class="divider-text">or</span>
				<div class="divider-line"></div>
			</div>

			<section class="social-wrapper">
				<ion-button *ngIf="showAppleSignIn" class="social-btn" fill="outline" color="primary" (click)="signInWithApple()">
					<ion-icon slot="start" name="logo-apple"></ion-icon>
					Continue with Apple
				</ion-button>
				<ion-button *ngIf="showGoogleSignIn" class="social-btn" fill="outline" color="primary" (click)="signInWithGoogle()">
					<ion-icon slot="start" name="logo-google"></ion-icon>
					Continue with Google
				</ion-button>
			</section>
		</ng-container>

		<div class="mode-switch-wrapper">
			<span class="mode-switch-text">No account?</span>
			<ion-button fill="clear" color="primary" class="mode-switch-link" (click)="switchMode('register')">
				Create one
			</ion-button>
		</div>
	</div>

	<!-- Register View (hidden, not destroyed, when inactive) -->
	<div [hidden]="mode !== 'register'">
		<form [formGroup]="registerForm" (ngSubmit)="onRegister()">
			<ion-list lines="none" class="form-list">
				<ion-row class="name-row">
					<ion-col size="6">
						<ion-item class="form-input">
							<ion-label position="floating">First Name</ion-label>
							<ion-input formControlName="first" clearInput></ion-input>
						</ion-item>
					</ion-col>
					<ion-col size="6">
						<ion-item class="form-input">
							<ion-label position="floating">Last Name</ion-label>
							<ion-input formControlName="last" clearInput></ion-input>
						</ion-item>
					</ion-col>
				</ion-row>

				<ion-item class="form-input">
					<ion-label position="floating">Email</ion-label>
					<ion-input type="email" formControlName="email" clearInput></ion-input>
				</ion-item>

				<ion-item class="form-input">
					<ion-label position="floating">Create Password</ion-label>
					<ion-input [type]="pwInputType" formControlName="password"></ion-input>
					<ion-button fill="clear" slot="end" (click)="togglePw()" class="password-toggle" aria-label="Toggle password visibility">
						<ion-icon *ngIf="pwInputType === 'password'" size="small" slot="icon-only" name="eye-off-outline" color="medium"></ion-icon>
						<ion-icon *ngIf="pwInputType === 'text'" size="small" slot="icon-only" name="eye-outline" color="secondary"></ion-icon>
					</ion-button>
				</ion-item>

				<ion-item class="form-input">
					<ion-label position="floating">Confirm Password</ion-label>
					<ion-input [type]="pwInputType" formControlName="passwordConfirm"></ion-input>
					<ion-button fill="clear" slot="end" (click)="togglePw()" class="password-toggle" aria-label="Toggle password visibility">
						<ion-icon *ngIf="pwInputType === 'password'" size="small" slot="icon-only" name="eye-off-outline" color="medium"></ion-icon>
						<ion-icon *ngIf="pwInputType === 'text'" size="small" slot="icon-only" name="eye-outline" color="secondary"></ion-icon>
					</ion-button>
				</ion-item>

				<ion-item class="newsletter-item" lines="none">
					<ion-checkbox formControlName="allow_marketing" slot="start" aria-label="Receive newsletter"></ion-checkbox>
					<ion-label class="newsletter-label">Receive Our Newsletter</ion-label>
				</ion-item>
			</ion-list>

			<ion-button [disabled]="!registerForm.valid" class="flow-submit" type="submit" expand="block">
				<ion-icon slot="start" name="person-add-outline"></ion-icon>
				Create Account
			</ion-button>
		</form>

		<ng-container *ngIf="showGoogleSignIn || showAppleSignIn">
			<div class="divider-wrapper">
				<div class="divider-line"></div>
				<span class="divider-text">or</span>
				<div class="divider-line"></div>
			</div>

			<section class="social-wrapper">
				<ion-button *ngIf="showAppleSignIn" class="social-btn" fill="outline" color="primary" (click)="signInWithApple()">
					<ion-icon slot="start" name="logo-apple"></ion-icon>
					Continue with Apple
				</ion-button>
				<ion-button *ngIf="showGoogleSignIn" class="social-btn" fill="outline" color="primary" (click)="signInWithGoogle()">
					<ion-icon slot="start" name="logo-google"></ion-icon>
					Continue with Google
				</ion-button>
			</section>
		</ng-container>

		<div class="mode-switch-wrapper">
			<span class="mode-switch-text">Already have an account?</span>
			<ion-button fill="clear" color="primary" class="mode-switch-link" (click)="switchMode('signin')">
				Sign in
			</ion-button>
		</div>
	</div>
</div>
